import React, { Fragment } from "react";

import { Dialog, Transition } from "@headlessui/react";
import styled from "styled-components";
import { Wallet3, Close } from "@styled-icons/remix-fill";
import ModalTabs from "../ModalTabs";
import Backend from "../../utils/Backend";
import {
  BlockchainType,
  DepositMethods,
  DevType,
  UserBalances,
  UserWallets,
} from "../../typings";
import EventManager from "../../utils/EventManager";

type Args = {
  backend: Backend;
  closeModal: any;
  publicKey: string;
  userId: string;
  depositMethods: DepositMethods;
  userBalances: UserBalances;
  events: EventManager;
  type: DevType;
  userFetchWalletAddresses: any;
  userWallets: UserWallets;
};
const Wallet = styled(Wallet3)`
  color: white;
`;

const CloseButton = styled(Close)`
  color: white;
`;
export default function ModalContent({
  backend,
  closeModal,
  publicKey,
  userId,
  depositMethods,
  userBalances,
  events,
  type,
  userFetchWalletAddresses,
  userWallets,
}: Args) {
  function generateNewAddress(blockchainType: BlockchainType) {
    return backend
      .userGenerateNewAddress(publicKey, userId, blockchainType)
      .then(() => {
        userFetchWalletAddresses();
      });
  }

  return (
    <Fragment>
      <div className="fixed inset-0 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4 text-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Dialog.Panel className="w-full max-w-md transform overflow-visible rounded-2xl bg-gray-700 p-6 text-left align-middle shadow-xl transition-all">
              <div className="py-1 flex static">
                <Wallet size={"24"} className="mr-2" />
                <Dialog.Title
                  as="h3"
                  className="text-lg font-medium leading-6 text-white"
                >
                  Wallet
                </Dialog.Title>
                <button className="absolute right-5" onClick={closeModal}>
                  <CloseButton size={"24"} />
                </button>
              </div>
              <ModalTabs
                depositMethods={depositMethods}
                userWallets={userWallets}
                generateNewAddress={generateNewAddress}
                userBalances={userBalances}
                events={events}
                type={type}
                closeMainModal={closeModal}
              ></ModalTabs>

              {/* <div className="mt-4">
                <button
                  type="button"
                  className="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                  onClick={closeModal}
                >
                  Got it, thanks!
                </button>
              </div> */}
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </div>
    </Fragment>
  );
}
